
import { useEffect } from "react";
import { BrowserRouter, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { SupportWidget } from "./components/support/SupportWidget";
import { CookieConsent } from "@/components/layout/CookieConsent";
import { SiteSchema } from "@/components/SiteSchema";
import { trackPageView } from "@/lib/analytics";

// Envia un evento page_view a Analytics en cada cambio de ruta. gtag('config') solo dispara la
// primera vista automaticamente -- en una SPA con React Router, la navegacion nunca vuelve a
// cargar la pagina, asi que sin esto Analytics solo veria una sola vista por visita entera.
function AnalyticsRouteTracker() {
  const location = useLocation();
  useEffect(() => {
    trackPageView(location.pathname + location.search);
  }, [location.pathname, location.search]);
  return null;
}

function App() {
  useEffect(() => {
    document.documentElement.lang = i18n.language;
    const handleLanguageChanged = (lng: string) => {
      document.documentElement.lang = lng;
    };
    i18n.on('languageChanged', handleLanguageChanged);
    return () => i18n.off('languageChanged', handleLanguageChanged);
  }, []);

  return (
    <HelmetProvider>
      <I18nextProvider i18n={i18n}>
        <BrowserRouter basename={__BASE_PATH__}>
          <SiteSchema />
          <AnalyticsRouteTracker />
          <AppRoutes />
          <CookieConsent />
          <SupportWidget />
        </BrowserRouter>
      </I18nextProvider>
    </HelmetProvider>
  );
}

export default App;
